export default __webpack_public_path__ + "static/media/mom talk.ac61368b.mp4";